import React from 'react';

const TempleStats = () => {
  const statsData = [
    {
      icon: '👥',
      number: '8+',
      unit: 'लाख',
      label: 'वार्षिक दर्शनार्थी',
      description: 'प्रतिवर्ष आने वाले श्रद्धालु',
      color: 'from-temple-primary to-temple-primary-dark'
    },
    {
      icon: '🚶‍♂️',
      number: '5+',
      unit: 'लाख',
      label: 'परिक्रमा काल में',
      description: 'मिथिला मध्य परिक्रमा के दौरान',
      color: 'from-temple-secondary to-yellow-500'
    },
    {
      icon: '🏛️',
      number: '15',
      unit: 'स्थल',
      label: 'परिक्रमा मार्ग',
      description: 'भारत-नेपाल के तीर्थ स्थल',
      color: 'from-temple-accent to-green-600'
    },
    {
      icon: '💰',
      number: '31.13',
      unit: 'करोड़',
      label: 'विकास बजट',
      description: 'सरकारी स्वीकृत राशि',
      color: 'from-blue-500 to-blue-700'
    },
    {
      icon: '📅',
      number: '2025',
      unit: 'वर्ष',
      label: 'ट्रस्ट स्थापना',
      description: 'आधिकारिक पंजीकरण',
      color: 'from-purple-500 to-purple-700'
    },
    {
      icon: '🎨',
      number: '1000+',
      unit: 'वर्ष',
      label: 'कला परंपरा',
      description: 'मधुबनी चित्रकला का इतिहास',
      color: 'from-pink-500 to-red-500'
    }
  ];

  const developmentMilestones = [
    {
      year: '2025',
      title: 'प्रगति यात्रा घोषणा',
      description: 'मुख्यमंत्री द्वारा विकास योजना की घोषणा',
      status: 'completed'
    },
    {
      year: '2025',
      title: 'वास्तुशिल्प समीक्षा',
      description: 'राष्ट्रीय स्तर के शिल्पकारों का दौरा',
      status: 'completed'
    },
    {
      year: '2026',
      title: 'मंदिर जीर्णोद्धार',
      description: 'गिरिजा स्थान का आधुनिकीकरण',
      status: 'ongoing'
    },
    {
      year: '2026',
      title: 'पुष्प वाटिका विकास',
      description: 'रामायणकालीन वनस्पति रोपण',
      status: 'planned'
    },
    {
      year: '2027',
      title: 'पर्यटन केंद्र',
      description: 'अंतर्राष्ट्रीय स्तर की सुविधाएं',
      status: 'planned'
    }
  ];

  return (
    <div className="space-y-8 sm:space-y-12">
      {/* Main Statistics Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {statsData.map((stat, index) => (
          <div key={index} className="bg-temple-bg-warm rounded-3xl p-6 shadow-temple border border-temple-primary/10 hover:shadow-temple-lg transition-all duration-300 hover:-translate-y-1">
            <div className={`bg-gradient-to-br ${stat.color} rounded-2xl p-4 mb-4`}>
              <div className="text-3xl text-white mb-2">{stat.icon}</div>
              <div className="text-white">
                <div className="flex items-baseline">
                  <span className="text-2xl sm:text-3xl font-bold">{stat.number}</span>
                  <span className="text-sm ml-1 opacity-90">{stat.unit}</span>
                </div>
              </div>
            </div>
            <h3 className="font-bold text-temple-text mb-2">{stat.label}</h3>
            <p className="text-sm text-temple-text-muted">{stat.description}</p>
          </div>
        ))}
      </div>

      {/* Development Timeline */}
      <div className="bg-temple-bg-warm rounded-3xl p-6 sm:p-8 shadow-temple border border-temple-primary/10">
        <h3 className="text-xl sm:text-2xl font-serif font-bold text-temple-text mb-6 flex items-center">
          <span className="mr-3">🗓️</span>
          विकास कालक्रम
        </h3>
        <div className="space-y-4">
          {developmentMilestones.map((milestone, index) => (
            <div key={index} className="flex items-start space-x-4 p-4 bg-temple-bg rounded-2xl border border-temple-primary/10">
              <div className="flex-shrink-0">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-sm ${
                  milestone.status === 'completed' ? 'bg-green-500' :
                  milestone.status === 'ongoing' ? 'bg-blue-500' :
                  'bg-gray-400'
                }`}>
                  {milestone.year}
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-bold text-temple-text">{milestone.title}</h4>
                  <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                    milestone.status === 'completed' ? 'bg-green-100 text-green-700' :
                    milestone.status === 'ongoing' ? 'bg-blue-100 text-blue-700' :
                    'bg-gray-100 text-gray-600'
                  }`}>
                    {milestone.status === 'completed' ? 'पूर्ण' :
                     milestone.status === 'ongoing' ? 'चालू' : 'नियोजित'}
                  </span>
                </div>
                <p className="text-sm text-temple-text-muted">{milestone.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Facts */}
      <div className="bg-temple-bg-warm rounded-3xl p-6 sm:p-8 shadow-temple border border-temple-primary/10">
        <h3 className="text-xl sm:text-2xl font-serif font-bold text-temple-text mb-6 flex items-center">
          <span className="mr-3">📋</span>
          त्वरित तथ्य
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h4 className="font-bold text-temple-text">भौगोलिक विवरण</h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-temple-text-muted">अक्षांश:</span>
                <span className="text-temple-text font-mono">26.589°N</span>
              </div>
              <div className="flex justify-between">
                <span className="text-temple-text-muted">देशांतर:</span>
                <span className="text-temple-text font-mono">85.907°E</span>
              </div>
              <div className="flex justify-between">
                <span className="text-temple-text-muted">समुद्र तल से ऊंचाई:</span>
                <span className="text-temple-text">56 मीटर</span>
              </div>
              <div className="flex justify-between">
                <span className="text-temple-text-muted">नेपाल सीमा से दूरी:</span>
                <span className="text-temple-text">8 किमी</span>
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <h4 className="font-bold text-temple-text">धार्मिक महत्व</h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-temple-text-muted">मुख्य देवता:</span>
                <span className="text-temple-text">श्री सीताराम जी</span>
              </div>
              <div className="flex justify-between">
                <span className="text-temple-text-muted">प्रमुख त्योहार:</span>
                <span className="text-temple-text">विवाह पंचमी</span>
              </div>
              <div className="flex justify-between">
                <span className="text-temple-text-muted">परिक्रमा अवधि:</span>
                <span className="text-temple-text">15 दिन</span>
              </div>
              <div className="flex justify-between">
                <span className="text-temple-text-muted">दर्शन समय:</span>
                <span className="text-temple-text">6:00 - 20:00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TempleStats;